import { useContext, ReactElement } from "react";

import { Navbar as BulmaNavbar } from "react-bulma-components";
import { useHistory } from "react-router-dom";

import { AuthContext } from "providers/CognitoAuthProvider";

export function SignOut(): ReactElement | null {
  const { signOut } = useContext(AuthContext);
  const history = useHistory();

  const handleSignOut = async () => {
    await signOut();
    history.push("/");
  };

  return (
    <BulmaNavbar.Item onClick={handleSignOut}>ログアウト</BulmaNavbar.Item>
  );
}
